import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api, SUBSTACK_URL } from "@/lib/api";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";

const fmt = (d) => {
  try { return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
  catch { return ""; }
};

export default function LatestSubstack({ limit = 3 }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/substack/latest?limit=${limit}`).then(({ data }) => setPosts(data || [])).catch(() => {});
  }, [limit]);

  if (!posts.length) return null;

  return (
    <section data-testid="latest-substack" className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-28">
      <FadeUp className="flex items-end justify-between mb-14 border-t border-ink/15 pt-12">
        <div>
          <p className="label text-ink/50 mb-4">From the Newsletter</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">Fresh on Substack</h2>
        </div>
        <a href={SUBSTACK_URL} target="_blank" rel="noopener noreferrer" data-testid="substack-viewall"
          className="hidden sm:inline-flex items-center gap-2 label link-underline pb-1">
          All posts <ArrowUpRight size={15} />
        </a>
      </FadeUp>

      <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
        {posts.map((p, i) => (
          <StaggerItem key={i}>
            <a href={p.link} target="_blank" rel="noopener noreferrer" data-testid={`substack-post-${i}`} className="group block h-full">
              {p.image ? (
                <div className="hover-img aspect-[16/10] bg-paper mb-5">
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover" />
                </div>
              ) : (
                <div className="aspect-[16/10] bg-ink mb-5 grain relative" />
              )}
              <p className="label text-ink/50 mb-2">{fmt(p.pubDate)}</p>
              <h3 className="font-display text-2xl font-bold leading-snug group-hover:text-ink/60 transition-colors">{p.title}</h3>
              <p className="mt-3 text-ink/70 leading-relaxed line-clamp-2">{p.summary}</p>
              <span className="inline-flex items-center gap-2 mt-4 label link-underline pb-1">Read on Substack <ArrowUpRight size={14} /></span>
            </a>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
